// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2oxTx","list":"PatternAutocomplete_list__2I3OX"};